import React, { useState } from 'react';
import styled from 'styled-components';

import blissWallpaper from 'assets/bliss.jpg';

const WALLPAPERS = [
    { name: 'Bliss', preview: blissWallpaper, color: null },
    { name: 'Azul', preview: null, color: '#336699' },
    { name: 'Follow', preview: null, color: '#663399' },
    { name: 'Red Moon', preview: null, color: '#993333' },
    { name: 'Radiance', preview: null, color: '#ff6600' },
    { name: 'Ascent', preview: null, color: '#224466' },
    { name: 'Autumn', preview: null, color: '#886633' },
    { name: 'Stonehenge', preview: null, color: '#555555' },
    { name: '(None)', preview: null, color: '#3a6bc5' },
];

function DisplayProperties({ onWallpaperChange }) {
    const [activeTab, setActiveTab] = useState('Desktop');
    const [selectedWallpaper, setSelectedWallpaper] = useState(0);

    const tabs = ['Themes', 'Desktop', 'Screen Saver', 'Appearance', 'Settings'];

    function applyWallpaper() {
        const wp = WALLPAPERS[selectedWallpaper];
        if (onWallpaperChange) {
            onWallpaperChange(wp);
        }
    }

    return (
        <Container>
            <div className="dp__tabs">
                {tabs.map(tab => (
                    <div
                        key={tab}
                        className={`dp__tab ${activeTab === tab ? 'dp__tab--active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </div>
                ))}
            </div>

            {activeTab === 'Desktop' && (
                <div className="dp__content">
                    <div className="dp__preview">
                        <div className="dp__monitor">
                            <div
                                className="dp__screen"
                                style={{
                                    background: WALLPAPERS[selectedWallpaper].preview
                                        ? `url(${WALLPAPERS[selectedWallpaper].preview}) center/cover`
                                        : WALLPAPERS[selectedWallpaper].color,
                                }}
                            />
                        </div>
                    </div>
                    <div className="dp__bg__section">
                        <label className="dp__label">Background:</label>
                        <div className="dp__bg__list">
                            {WALLPAPERS.map((wp, i) => (
                                <div
                                    key={wp.name}
                                    className={`dp__bg__item ${selectedWallpaper === i ? 'dp__bg__item--selected' : ''}`}
                                    onClick={() => setSelectedWallpaper(i)}
                                >
                                    <div
                                        className="dp__bg__swatch"
                                        style={{
                                            background: wp.preview
                                                ? `url(${wp.preview}) center/cover`
                                                : wp.color,
                                        }}
                                    />
                                    {wp.name}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {activeTab === 'Screen Saver' && (
                <div className="dp__content">
                    <div className="dp__preview">
                        <div className="dp__monitor">
                            <div className="dp__screen" style={{ background: '#000', color: '#0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'monospace', fontSize: '8px' }}>
                                Matrix Screensaver
                            </div>
                        </div>
                    </div>
                    <div className="dp__ss__section">
                        <label className="dp__label">Screen saver:</label>
                        <div className="dp__select__row">
                            <select className="dp__select">
                                <option>Matrix Rain</option>
                                <option>3D Pipes</option>
                                <option>Starfield</option>
                                <option>(None)</option>
                            </select>
                        </div>
                        <div className="dp__wait__row">
                            <span>Wait: 5 minutes</span>
                        </div>
                    </div>
                </div>
            )}

            {activeTab === 'Themes' && (
                <div className="dp__content">
                    <div className="dp__theme__section">
                        <label className="dp__label">Theme:</label>
                        <select className="dp__select" style={{ width: '100%' }}>
                            <option>Windows XP (Modified)</option>
                            <option>Windows Classic</option>
                        </select>
                        <p className="dp__theme__note">
                            This desktop is a custom Dead Simple Computing theme designed to show what happens when you don't invest in IT support.
                        </p>
                        <p className="dp__theme__note">
                            For a professionally managed desktop, call <strong>0118 359 2220</strong>.
                        </p>
                    </div>
                </div>
            )}

            {activeTab === 'Appearance' && (
                <div className="dp__content">
                    <div className="dp__theme__section">
                        <label className="dp__label">Windows and buttons:</label>
                        <select className="dp__select" style={{ width: '100%' }}>
                            <option>Windows XP style</option>
                            <option>Windows Classic style</option>
                        </select>
                        <label className="dp__label" style={{ marginTop: 12 }}>Color scheme:</label>
                        <select className="dp__select" style={{ width: '100%' }}>
                            <option>Default (Blue)</option>
                            <option>Olive Green</option>
                            <option>Silver</option>
                        </select>
                        <label className="dp__label" style={{ marginTop: 12 }}>Font size:</label>
                        <select className="dp__select" style={{ width: '100%' }}>
                            <option>Normal</option>
                            <option>Large Fonts</option>
                            <option>Extra Large Fonts</option>
                        </select>
                    </div>
                </div>
            )}

            {activeTab === 'Settings' && (
                <div className="dp__content">
                    <div className="dp__theme__section">
                        <label className="dp__label">Screen resolution:</label>
                        <input type="range" min="800" max="1920" step="1" defaultValue="1024" className="dp__slider" />
                        <div className="dp__resolution__labels">
                            <span>Less</span><span>More</span>
                        </div>
                        <div className="dp__resolution__value">1024 × 768 pixels</div>
                        <label className="dp__label" style={{ marginTop: 12 }}>Color quality:</label>
                        <select className="dp__select" style={{ width: '100%' }}>
                            <option>Highest (32 bit)</option>
                            <option>Medium (16 bit)</option>
                        </select>
                    </div>
                </div>
            )}

            <div className="dp__buttons">
                <button className="dp__xp__btn" onClick={applyWallpaper}>OK</button>
                <button className="dp__xp__btn">Cancel</button>
                <button className="dp__xp__btn" onClick={applyWallpaper}>Apply</button>
            </div>
        </Container>
    );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ece9d8;
  font-family: Tahoma, sans-serif;
  font-size: 11px;

  .dp__tabs {
    display: flex;
    padding: 4px 4px 0;
    gap: 0;
  }
  .dp__tab {
    padding: 4px 12px;
    background: #d6d3c6;
    border: 1px solid #999;
    border-bottom: none;
    cursor: pointer;
    font-size: 11px;
    margin-right: -1px;
    position: relative;
    &:hover { background: #e8e5d8; }
    &--active {
      background: #ece9d8;
      border-bottom: 1px solid #ece9d8;
      z-index: 1;
      font-weight: bold;
    }
  }

  .dp__content {
    flex: 1;
    border: 1px solid #999;
    margin: 0 4px;
    padding: 12px;
    overflow-y: auto;
  }

  .dp__preview {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
  }
  .dp__monitor {
    width: 180px;
    height: 120px;
    background: #333;
    border-radius: 6px;
    padding: 10px 12px 16px;
    box-shadow: 2px 2px 6px rgba(0,0,0,0.3);
  }
  .dp__screen {
    width: 100%;
    height: 100%;
    border-radius: 2px;
    background: #3a6bc5;
  }

  .dp__bg__section, .dp__ss__section, .dp__theme__section {
    padding: 0;
  }
  .dp__label {
    display: block;
    font-weight: bold;
    margin-bottom: 4px;
    color: #333;
  }
  .dp__bg__list {
    border: 1px solid #7f9db9;
    background: white;
    max-height: 140px;
    overflow-y: auto;
    padding: 2px;
  }
  .dp__bg__item {
    padding: 3px 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    &:hover { background: #e8f0ff; }
    &--selected { background: #316ac5; color: #fff; }
  }
  .dp__bg__swatch {
    width: 20px;
    height: 14px;
    border: 1px solid #999;
    flex-shrink: 0;
  }

  .dp__select__row, .dp__wait__row {
    margin: 8px 0;
  }
  .dp__select {
    padding: 2px 4px;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    border: 1px solid #7f9db9;
  }
  .dp__slider {
    width: 100%;
    margin: 4px 0;
  }
  .dp__resolution__labels {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    color: #666;
  }
  .dp__resolution__value {
    text-align: center;
    font-weight: bold;
    margin-top: 4px;
    color: #003399;
  }
  .dp__theme__note {
    margin: 8px 0;
    color: #666;
    line-height: 1.5;
    strong { color: #003399; }
  }

  .dp__buttons {
    padding: 8px;
    display: flex;
    justify-content: flex-end;
    gap: 4px;
  }
  .dp__xp__btn {
    padding: 4px 18px;
    background: linear-gradient(to bottom, #fff, #e3e3e3);
    border: 1px solid #999;
    border-radius: 2px;
    cursor: pointer;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    min-width: 70px;
    &:hover { background: linear-gradient(to bottom, #e3e3e3, #fff); }
    &:active { background: #ccc; }
  }
`;

export default DisplayProperties;
